/* Chippys one-page site: real Shopify cart drawer, cart count, toast. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = document.querySelector('[data-cart-drawer]');
  var body = document.querySelector('[data-cart-body]');
  var subtotal = document.querySelector('[data-cart-subtotal]');
  var countEl = document.querySelector('[data-cart-count]');
  var toggle = document.querySelector('[data-cart-open]');
  var checkout = document.querySelector('[data-cart-checkout]');
  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.dataset.visible = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.dataset.visible = 'false'; }, 2600);
  }

  function render(cart) {
    var n = cart.item_count || 0;
    if (countEl) { countEl.textContent = n; countEl.dataset.hidden = n === 0 ? 'true' : 'false'; }
    if (toggle) toggle.setAttribute('aria-label', 'Open cart, ' + n + ' item' + (n === 1 ? '' : 's'));
    if (subtotal) subtotal.textContent = money(cart.total_price || 0);
    if (checkout) checkout.setAttribute('aria-disabled', n === 0 ? 'true' : 'false');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty. Add some crunch.</p>';
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="cart-item">' +
        (img ? '<img class="cart-item__img" src="' + esc(img) + '" alt="">' : '<span class="cart-item__img"></span>') +
        '<div>' +
          '<p class="cart-item__name">' + esc(item.product_title) + '</p>' +
          '<p class="cart-item__meta">' + esc(variant) + '</p>' +
          '<div class="cart-item__qty">' +
            '<button type="button" data-line-change="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line-change="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-line-change="' + esc(item.key) + '" data-qty="0">Remove</button>' +
        '</div>' +
        '<p class="cart-item__price">' + money(item.final_line_price) + '</p>' +
      '</div>';
    }).join('');
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function change(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function open() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-cart-close]');
    if (c) setTimeout(function () { c.focus(); }, 50);
  }
  function close() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (toggle) toggle.focus();
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () { refresh(); open(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') close();
  });
  if (body) {
    body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line-change]');
      if (!b) return;
      b.disabled = true;
      change(b.dataset.lineChange, Math.max(0, parseInt(b.dataset.qty, 10) || 0));
    });
  }
  if (checkout) {
    checkout.addEventListener('click', function (e) {
      if (checkout.getAttribute('aria-disabled') === 'true') { e.preventDefault(); toast('Your cart is empty.'); }
    });
  }

  window.ChippysCart = {
    refresh: refresh,
    open: open,
    close: close,
    toast: toast,
    added: function (title) {
      return refresh().then(function () { toast('Added ' + title + ' to your cart'); open(); });
    }
  };
  refresh();
})();
